import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import s, { getFontFamily } from './Typography.styles';

export type Caption4Props = RNTextProps & {
  weight?: 'regular' | 'bold';
  uppercase?: boolean;
};

export const Caption4: React.FC<Caption4Props> = ({
  children,
  weight = 'regular',
  uppercase = false,
  style,
  ...props
}) => {
  return (
    <RNText
      style={[
        s.common,
        s.caption4,
        uppercase && s.caption4Caps,
        {
          textTransform: uppercase ? 'uppercase' : 'none',
        },
        getFontFamily(weight),
        style,
      ]}
      {...props}
    >
      {children}
    </RNText>
  );
};
